export class WaterfallsCreateDto {
  distributionDate: Date;
  distributionPeriod: string;
  distributionAmount: number;
  distributionStartDate: Date;
  distributionEndDate: Date;
}
